var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showImage && !_vm.isKeybeProfile)?_c('img',{staticClass:"KeybeAvatar-img",style:(Object.assign({}, {minWidth: _vm.size+'px',
    minHeight: _vm.size+'px',
    maxWidth: _vm.size+'px',
    maxHeight: _vm.size+'px',
    objectFit: _vm.objectFit},
    _vm.additionalStyles)),attrs:{"src":_vm.imgUrl,"alt":""},on:{"error":function($event){_vm.imgUrl=''}}}):(_vm.isKeybeProfile)?_c('div',{style:(_vm.style)},[_c('KeybeIcon',{attrs:{"icon":_vm.KeybeIconType.LOGO,"color":_vm.Colors.kbGreen}})],1):_c('KeybeIcon',{style:(_vm.style),attrs:{"icon":_vm.KeybeIconType.DEFAULT_USER}})}
var staticRenderFns = []

export { render, staticRenderFns }